<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document">Task Arrangement</i>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row>
                <el-col :span="24" class="searchbar">
                    <el-col :span="3">
                        <label class="searchtitle">Country</label>
                        <el-select v-model="selectcountryvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectcountryoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Brand</label>
                        <el-select v-model="selectbrandvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectbrandoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Project</label>
                        <el-select v-model="selectprojectvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectprojectoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="3">
                        <label class="searchtitle">Version</label>
                        <!-- <el-select v-model="selectswversionvalue" filterable placeholder="please select">
                            <el-option
                            v-for="item in selectswversionoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                        <el-input
                            style="width:100%;"
                            placeholder="Please Enter SW Version"
                            v-model="selectswversionvalue"
                            clearable>
                        </el-input>
                    </el-col>
                    <el-col :span="6" style="margin-top:20px;">
                        <el-button size="small" style="margin-left:5px;" type="success" @click="searchTaskArrangement(pagesize,currentpage)">S E A R C H</el-button>
                        <el-button size="small" type="info" @click="clearTaskArrangement">C L E A R</el-button>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-button size="small" type="success" icon="el-icon-download" @click="exportTaskArrangement">EXPORT</el-button>
                    <!-- <el-button size="small" type="warning" icon="el-icon-circle-plus" @click="dialogAddNewTaskArrangementVisible = true">ADD NEW</el-button> -->
                    <el-button size="small" type="warning" icon="el-icon-circle-plus" @click="openNewWebsite">ADD NEW</el-button>
                    <el-dialog title="ADD NEW TASK ARRANGEMENT INFO" :visible.sync="dialogAddNewTaskArrangementVisible">
                        <el-form label-position="left" label-width="150px" class="AddNewTaskArrangementForm">
                            <el-form-item label="Project">
                                <el-select class="formselect" @change="AddNewselectprojectaction();AddNewselectprojecttocountryaction();" v-model="AddNewTaskArrangementFormproject" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectprojectoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="AddNewTaskArrangementFormproject" placeholder="Please Enter Project"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Country">
                                <el-select class="formselect" @change="AddNewselectcountryaction()" v-model="AddNewTaskArrangementFormcountry" style="width:80%" filterable placeholder="please select" multiple>
                                    <el-option
                                    v-for="item in selectcountryoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-button type="primary" @click="AddNewTaskArrangementFormcountry=''" style="width:20%" >Clear</el-button>
                                <!-- <el-input v-model="AddNewTaskArrangementFormcountry" placeholder="Please Enter Country"></el-input> -->
                            </el-form-item>
                            <el-form-item label="SW Version">
                                <el-input v-model="AddNewTaskArrangementFormswversion" placeholder="Please Enter SW Version"></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="Submit Date">
                                <el-input v-model="AddNewTaskArrangementFormsubmitdate" placeholder="Please Enter Submit Date"></el-input>
                            </el-form-item> -->
                            <el-form-item label="SW Type">
                                <el-select class="formselect" v-model="AddNewTaskArrangementFormswtype" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectswtypeoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="AddNewTaskArrangementFormswtype" placeholder="Please Enter SW Type"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Test Period">
                                <el-input v-model="AddNewTaskArrangementFormtestperiod" placeholder="Please Enter Test Period"></el-input>
                            </el-form-item>
                            <el-form-item label="Test Plan">
                                <el-input v-model="AddNewTaskArrangementFormtestplan" placeholder="Please Enter Test Plan"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Link">
                                <el-input v-model="AddNewTaskArrangementFormswlink" placeholder="Please Enter SW Link"></el-input>
                            </el-form-item>
                            <el-form-item label="PassWord">
                                <el-input v-model="AddNewTaskArrangementFormpassword" placeholder="Please Enter PassWord"></el-input>
                            </el-form-item>
                            <el-form-item label="TPM">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormtpm" placeholder="Please Enter TPM's Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Project Leader">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormprojectleader" placeholder="Please Enter PL's Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Type">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormtype" placeholder="Please Enter Type"></el-input>
                            </el-form-item>
                            <el-form-item label="Brand">
                                <el-select class="formselect" disabled v-model="AddNewTaskArrangementFormbrand" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectbrandoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="AddNewTaskArrangementFormbrand" placeholder="Please Enter Brand"></el-input> -->
                            </el-form-item>
                            <el-form-item label="PPM">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormppm" placeholder="Please Enter PPM"></el-input>
                            </el-form-item>
                            <el-form-item label="SPM">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormspm" placeholder="Please Enter SPM"></el-input>
                            </el-form-item>
                            <el-form-item label="Flash Tool">
                                <el-input :disabled="true" v-model="AddNewTaskArrangementFormflashtool" placeholder="Please Enter Flash Tool"></el-input>
                            </el-form-item>
                            <el-form-item label="Comment">
                                <el-input type="textarea" :autosize="{ minRows: 3}" v-model="AddNewTaskArrangementFormcomment" placeholder="Please Enter Comment"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogAddNewTaskArrangementVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="AddNewTaskArrangement">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-table
                        ref="TaskArrangementTable"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData"
                        height="500"
                        border
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                            type="selection"
                            width="5px">
                        </el-table-column> -->
                        <el-table-column
                            prop="id"
                            label="ID"
                            align="center"
                            v-if="idshow"
                            width="10px">
                        </el-table-column>
                        <el-table-column
                            prop="project"
                            label="Project"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swversion"
                            label="SW Version"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <a  herf='#'
                                    v-clipboard:copy="scope.row.swversion"
                                    v-clipboard:success="onCopy"
                                    v-clipboard:error="onError">
                                    {{ scope.row.swversion }}
                                </a>                               
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="countrych"
                            label="Country"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="type"
                            label="Type"
                            align="center"
                            width="60px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="brand"
                            label="Brand"
                            align="center"
                            width="80px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swtype"
                            label="SW Type"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testperiod"
                            label="Test Period"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="projectleader"
                            label="PL"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="ppm"
                            label="PPM"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="spm"
                            label="SPM"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="tpm"
                            label="TPM"
                            align="center"
                            width="100px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testplan"
                            label="Test Plan"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="swlink"
                            label="SW Link"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="password"
                            label="Password"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="submitdate"
                            label="Submit Date"
                            align="center"
                            width="110px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="testertranslater"
                            label="Tester Translater"
                            v-if="idshow"
                            align="center"
                            width="140px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="countryID"
                            label="Country ID"
                            v-if="idshow"
                            align="center"
                            width="150px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="flashtool"
                            label="Flash Tool"
                            align="center"
                            width="200px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="comment"
                            label="Comment"
                            align="center"
                            width="200px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column 
                            fixed="right"
                            label="Operation"
                            align="center"
                            width="100px">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                @click="dialogEditTaskArrangementVisible = true;handleEdit(scope.$index, scope.row);">Edit</el-button>                                
                                <!-- <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Delete</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-dialog title="EDIT TASK ARRANGEMENT INFO" :visible.sync="dialogEditTaskArrangementVisible">
                        <el-form label-position="left" label-width="150px" class="EditTaskArrangementForm">
                            <el-form-item label="Type">
                                <el-input :disabled="true" v-model="EditTaskArrangementFormtype" placeholder="Please Enter Type"></el-input>
                            </el-form-item>
                            <el-form-item label="Brand">
                                <el-select class="formselect" disabled v-model="EditTaskArrangementFormbrand" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectbrandoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="EditTaskArrangementFormbrand" placeholder="Please Enter Brand"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Project">
                                <el-select class="formselect" :disabled="true" v-model="EditTaskArrangementFormproject" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectprojectoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="EditTaskArrangementFormproject" placeholder="Please Enter Project"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Country">
                                <el-select class="formselect" :disabled="true" @change="Editselectcountryaction()" v-model="EditTaskArrangementFormcountry" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectcountryoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="EditTaskArrangementFormcountry" placeholder="Please Enter Country"></el-input> -->
                            </el-form-item>
                            <el-form-item label="SW Version">
                                <el-input v-model="EditTaskArrangementFormswversion" placeholder="Please Enter SW Version"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Type">
                                <el-select class="formselect" v-model="EditTaskArrangementFormswtype" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectswtypeoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="EditTaskArrangementFormswtype" placeholder="Please Enter SW Type"></el-input> -->
                            </el-form-item>
                            <el-form-item label="Test Period">
                                <el-input v-model="EditTaskArrangementFormtestperiod" placeholder="Please Enter Test Period"></el-input>
                            </el-form-item>
                            <el-form-item label="Project Leader">
                                <el-input :disabled="true" v-model="EditTaskArrangementFormprojectleader" placeholder="Please Enter PL's Email"></el-input>
                            </el-form-item>
                            <el-form-item label="PPM">
                                <el-input :disabled="true" v-model="EditTaskArrangementFormppm" placeholder="Please Enter PPM"></el-input>
                            </el-form-item>
                            <el-form-item label="SPM">
                                <el-input :disabled="true" v-model="EditTaskArrangementFormspm" placeholder="Please Enter SPM"></el-input>
                            </el-form-item>
                            <el-form-item label="TPM">
                                <el-input :disabled="true" v-model="EditTaskArrangementFormtpm" placeholder="Please Enter TPM's Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Test Plan">
                                <el-input v-model="EditTaskArrangementFormtestplan" placeholder="Please Enter Test Plan"></el-input>
                            </el-form-item>
                            <el-form-item label="SW Link">
                                <el-input v-model="EditTaskArrangementFormswlink" placeholder="Please Enter SW Link"></el-input>
                            </el-form-item>
                            <el-form-item label="Password">
                                <el-input v-model="EditTaskArrangementFormpassword" placeholder="Please Enter Password"></el-input>
                            </el-form-item>
                            <el-form-item label="Flash Tool">
                                <el-input v-model="EditTaskArrangementFormflashtool" placeholder="Please Enter Flash Tool"></el-input>
                            </el-form-item>
                            <el-form-item label="Comment">
                                <el-input type="textarea" :autosize="{ minRows: 3}" v-model="EditTaskArrangementFormcomment" placeholder="Please Enter Comment"></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogEditTaskArrangementVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="EditTaskArrangement">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-sizes="[8, 15, 30, 50]"
                        :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="currentTotal"
                        >
                    </el-pagination>
                    <!-- <div style="margin-top: 20px">
                        <el-button @click="ClearSelection">cancel选择</el-button>
                        <el-button @click="AllSelection">全选</el-button>
                    </div> -->
                </el-col>
            </el-row>
        </div>    
    </div>
</template>

<script>
import { exportTaskArrangementData,MulitCountryInfoData,TaskArrangementprojectInfoData,searchprojectInfoData,GetProjectInfoSelectOption,searchTaskArrangementData,AddNewTaskArrangementData,EditTaskArrangementData,DeleteTaskArrangementData,GetTaskArrangementSelectOption,TaskArrangementprojectcountryInfoData } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            currentpage: 1,
            pagesize: 8,
            currentTotal: 0,
            tableData: [],
            multipleSelection: [],
            loading: false,
            idshow: false,
            selectcountryoptions: [],
            selectcountryvalue: '',
            selectprojectoptions: [],
            selectprojectvalue: '',
            selectswversionoptions: [],
            selectswversionvalue: '',
            selectbrandvalue: '',
            selectbrandoptions: [],
            selectswtypeoptions: [],
            AddNewselectprojecttocountryoptions: [],
            dialogAddNewTaskArrangementVisible:false,
            AddNewTaskArrangementFormtype: '',
            AddNewTaskArrangementFormbrand: '',
            AddNewTaskArrangementFormproject: '',
            AddNewTaskArrangementFormcountry: '',
            AddNewTaskArrangementFormcountryback: [],
            AddNewTaskArrangementFormswversion: '',
            AddNewTaskArrangementFormsubmitdate: '',
            AddNewTaskArrangementFormswtype: '',
            AddNewTaskArrangementFormtestperiod: '',
            AddNewTaskArrangementFormprojectleader: '',
            AddNewTaskArrangementFormppm: '',
            AddNewTaskArrangementFormspm: '',
            AddNewTaskArrangementFormtpm: '',
            AddNewTaskArrangementFormtestplan: '',
            AddNewTaskArrangementFormswlink: '',
            AddNewTaskArrangementFormpassword: '',
            AddNewTaskArrangementFormflashtool: '',
            AddNewTaskArrangementFormcomment: '',
            dialogEditTaskArrangementVisible:false,
            EditTaskArrangementFormtype: '',
            EditTaskArrangementFormbrand: '',
            EditTaskArrangementFormproject: '',
            EditTaskArrangementFormcountry: '',
            EditTaskArrangementFormcountryID: '',
            EditTaskArrangementFormtestertranslater: '',
            EditTaskArrangementFormcountryback: [],
            EditTaskArrangementFormswversion: '',
            EditTaskArrangementFormsubmitdate: '',
            EditTaskArrangementFormswtype: '',
            EditTaskArrangementFormtestperiod: '',
            EditTaskArrangementFormprojectleader: '',
            EditTaskArrangementFormppm: '',
            EditTaskArrangementFormspm: '',
            EditTaskArrangementFormtpm: '',
            EditTaskArrangementFormtestplan: '',
            EditTaskArrangementFormswlink: '',
            EditTaskArrangementFormpassword: '',
            EditTaskArrangementFormflashtool: '',
            EditTaskArrangementFormcomment: '',
        };
    },
    created() {
        let token = this.$store.getters.idToken;
        searchTaskArrangementData ({
            countrych: "",
            brand: "",
            project: "",
            swversion: "",
            pagesize: this.pagesize,
            currentpage: this.currentpage
        },token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.count;
        }).catch(error => console.log(error));
        GetTaskArrangementSelectOption (token).then(res => {
            console.log(res);
            this.selectcountryoptions = res.countrych;
            // this.selectprojectoptions = res.project;
            this.selectbrandoptions = res.brand;
            this.selectswtypeoptions = res._type;
        }).catch(error => console.log(error));
        GetProjectInfoSelectOption (token).then(res => {
            console.log(res);
            this.selectprojectoptions = res.project;
        }).catch(error => console.log(error));
    },
    methods: {
        openNewWebsite() {
            window.open("https://gl-tones.transsion.com/TaskArrangement")
        },
        handleSizeChange(val) {
            this.pagesize = val;
            console.log(`每页 ${val} 条`);
            this.searchTaskArrangement(val,this.currentpage);
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            console.log(`当前页: ${val}`);
            this.searchTaskArrangement(this.pagesize,val);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        handleEdit(index, row) {
            console.log(index, row);
            this.EditTaskArrangementFormid = row.id ;
            this.EditTaskArrangementFormtype = row.type ;
            this.EditTaskArrangementFormbrand = row.brand ;
            this.EditTaskArrangementFormproject = row.project ;
            this.EditTaskArrangementFormcountry = row.countrych ;
            this.EditTaskArrangementFormcountryID = row.countryID ;
            this.EditTaskArrangementFormtestertranslater = row.testertranslater ;
            this.EditTaskArrangementFormswversion = row.swversion ;
            this.EditTaskArrangementFormsubmitdate = row.submitdate ;
            this.EditTaskArrangementFormswtype = row.swtype ;
            this.EditTaskArrangementFormtestperiod = row.testperiod ;
            this.EditTaskArrangementFormprojectleader = row.projectleader ;
            this.EditTaskArrangementFormppm = row.ppm ;
            this.EditTaskArrangementFormspm = row.spm ;
            this.EditTaskArrangementFormtpm = row.tpm ;
            this.EditTaskArrangementFormtestplan = row.testplan ;
            this.EditTaskArrangementFormswlink = row.swlink ;
            this.EditTaskArrangementFormpassword = row.password ;
            this.EditTaskArrangementFormflashtool = row.flashtool ;
            this.EditTaskArrangementFormcomment = row.comment ;
        },
        handleDelete(index, row) {
            let token = this.$store.getters.idToken;
            console.log(index, row);
            console.log(row.id);
            this.$confirm('此Operation将永久Delete该文件, 是否继续?', '提示', {
                confirmButtonText: 'OK',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                DeleteTaskArrangementData ({
                    id: row.id
                },token).then(res => {
                    console.log(res);
                    this.tableData.splice(((this.currentpage-1)*this.pagesize+index), 1);
                    this.currentTotal--;
                    this.$message({
                        type: 'success',
                        message: 'Delete successful'
                    });
                    GetTaskArrangementSelectOption (token).then(res => {
                        console.log(res);
                        this.selectcountryoptions = res.countrych;
                        // this.selectprojectoptions = res.project;
                        this.selectbrandoptions = res.brand;
                        this.selectswtypeoptions = res._type;
                    }).catch(error => console.log(error));
                    GetProjectInfoSelectOption (token).then(res => {
                        console.log(res);
                        this.selectprojectoptions = res.project;
                    }).catch(error => console.log(error));
                }).catch(error => console.log(error));
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Delete canceled'
                });          
            });            
        },
        searchTaskArrangement (pagesize,currentpage) {
            let token = this.$store.getters.idToken;
            this.loading = true;
            searchTaskArrangementData ({
                countrych: this.selectcountryvalue,
                project: this.selectprojectvalue,
                brand: this.selectbrandvalue,
                swversion: this.selectswversionvalue,
                pagesize: pagesize,
                currentpage: currentpage
            },token).then(res => {
                this.tableData = res.results;
                console.log(res.results);
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetTaskArrangementSelectOption (token).then(res => {
                console.log(res);
                this.selectcountryoptions = res.countrych;
                // this.selectprojectoptions = res.project;
                this.selectbrandoptions = res.brand;
                this.selectswtypeoptions = res._type;
            }).catch(error => console.log(error));
            GetProjectInfoSelectOption (token).then(res => {
                console.log(res);
                this.selectprojectoptions = res.project;
            }).catch(error => console.log(error));
        },
        clearTaskArrangement () {
            let token = this.$store.getters.idToken;
            this.selectcountryvalue = "";
            this.selectprojectvalue = "";
            this.selectbrandvalue = "";
            this.selectswversionvalue = "";
            this.currentpage = 1;
            this.loading = true;
            searchTaskArrangementData ({
                countrych: "",
                project: "",
                brand: "",
                swversion: "",
                pagesize: this.pagesize,
                currentpage: this.currentpage
            },token).then(res => {
                this.tableData = res.results;
                console.log(res.results);
                this.currentTotal = res.count;
                this.loading = false;
            }).catch(error => console.log(error));
            GetTaskArrangementSelectOption (token).then(res => {
                console.log(res);
                this.selectcountryoptions = res.countrych;
                // this.selectprojectoptions = res.project;
                this.selectbrandoptions = res.brand;
                this.selectswtypeoptions = res._type;
            }).catch(error => console.log(error));
            GetProjectInfoSelectOption (token).then(res => {
                console.log(res);
                this.selectprojectoptions = res.project;
            }).catch(error => console.log(error));
        },
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        AddNewTaskArrangement() {
            // alert("AddNewTaskArrangement");
            let token = this.$store.getters.idToken;
            var ArrangementFormcountryback = this.AddNewTaskArrangementFormcountryback;
            var today = this.getNowFormatDate();
            if(this.AddNewTaskArrangementFormcountry == '') {
                this.$message({
                    type: 'warning',
                    message: "Country 不能为空！"
                });
                return false;
            }
            if(this.AddNewTaskArrangementFormswlink == '') {
                this.$message({
                    type: 'warning',
                    message: "SW Link 不能为空！"
                });  
                return false;
            }
            if(this.AddNewTaskArrangementFormswtype == '') {
                this.$message({
                    type: 'warning',
                    message: "SW Type 不能为空！"
                });  
                return false;
            }
            if(this.AddNewTaskArrangementFormswversion == '') {
                this.$message({
                    type: 'warning',
                    message: "SW Version 不能为空！"
                });  
                return false;
            }
            if(this.AddNewTaskArrangementFormtestplan == '') {
                this.$message({
                    type: 'warning',
                    message: "Test Plan 不能为空！"
                });  
                return false;
            }
            for(var i = 0;i<ArrangementFormcountryback.length;i++){
                // alert("AddNewTaskArrangement2-0-1");
                const AddNewTaskArrangementFormData = {
                    type: this.AddNewTaskArrangementFormtype,
                    brand: this.AddNewTaskArrangementFormbrand,
                    project: this.AddNewTaskArrangementFormproject,
                    countrych: ArrangementFormcountryback[i][0],
                    countryID: ArrangementFormcountryback[i][1],
                    testertranslater: ArrangementFormcountryback[i][2],
                    swversion: this.AddNewTaskArrangementFormswversion,
                    // submitdate: this.AddNewTaskArrangementFormsubmitdate,
                    swtype: this.AddNewTaskArrangementFormswtype,
                    testperiod: this.AddNewTaskArrangementFormtestperiod,
                    projectleader: this.AddNewTaskArrangementFormprojectleader,
                    ppm: this.AddNewTaskArrangementFormppm,
                    spm: this.AddNewTaskArrangementFormspm,
                    tpm: this.AddNewTaskArrangementFormtpm,
                    testplan: this.AddNewTaskArrangementFormtestplan,
                    swlink: this.AddNewTaskArrangementFormswlink,
                    flashtool: this.AddNewTaskArrangementFormflashtool,
                    comment: this.AddNewTaskArrangementFormcomment,
                    password: this.AddNewTaskArrangementFormpassword
                }
                // alert("AddNewTaskArrangement2-1");
                this.tableData.push({
                    type: this.AddNewTaskArrangementFormtype,
                    brand: this.AddNewTaskArrangementFormbrand,
                    project: this.AddNewTaskArrangementFormproject,
                    countrych: ArrangementFormcountryback[i][0],
                    countryID: ArrangementFormcountryback[i][1],
                    testertranslater: ArrangementFormcountryback[i][2],
                    swversion: this.AddNewTaskArrangementFormswversion,
                    submitdate: today,
                    swtype: this.AddNewTaskArrangementFormswtype,
                    testperiod: this.AddNewTaskArrangementFormtestperiod,
                    projectleader: this.AddNewTaskArrangementFormprojectleader,
                    ppm: this.AddNewTaskArrangementFormppm,
                    spm: this.AddNewTaskArrangementFormspm,
                    tpm: this.AddNewTaskArrangementFormtpm,
                    testplan: this.AddNewTaskArrangementFormtestplan,
                    swlink: this.AddNewTaskArrangementFormswlink,
                    comment: this.AddNewTaskArrangementFormcomment,
                    password: this.AddNewTaskArrangementFormpassword
                });
                this.currentTotal++;
                // alert("AddNewTaskArrangement2-2");
                AddNewTaskArrangementData (AddNewTaskArrangementFormData,token).then(res => {
                    if (res.code == 1) {
                        console.log(res);
                        console.log(this.tableData);
                        this.$message({
                            message: 'Added successfully',
                            type: 'success'
                        });
                        GetTaskArrangementSelectOption (token).then(res => {
                            console.log(res);
                            this.selectcountryoptions = res._country;
                            // this.selectprojectoptions = res.project;
                            this.selectbrandoptions = res.brand;
                            this.selectswtypeoptions = res._type;
                        }).catch(error => console.log(error));
                        GetProjectInfoSelectOption (token).then(res => {
                            console.log(res);
                            this.selectprojectoptions = res.project;
                        }).catch(error => console.log(error));
                        this.AddNewTaskArrangementFormtype = "";
                        this.AddNewTaskArrangementFormbrand = "";
                        this.AddNewTaskArrangementFormproject = "";
                        this.AddNewTaskArrangementFormcountry = "";
                        this.AddNewTaskArrangementFormswversion = "";
                        this.AddNewTaskArrangementFormsubmitdate = "";
                        this.AddNewTaskArrangementFormswtype = "";
                        this.AddNewTaskArrangementFormtestperiod = "";
                        this.AddNewTaskArrangementFormprojectleader = "";
                        this.AddNewTaskArrangementFormppm = "";
                        this.AddNewTaskArrangementFormspm = "";
                        this.AddNewTaskArrangementFormtpm = "";
                        this.AddNewTaskArrangementFormtestplan = "";
                        this.AddNewTaskArrangementFormswlink = "";
                        this.AddNewTaskArrangementFormpassword = "";
                        this.AddNewTaskArrangementFormflashtool = "";
                        this.AddNewTaskArrangementFormcomment = "";
                        this.dialogAddNewTaskArrangementVisible = false;                    
                    }else {
                        this.$message({
                            type: 'warning',
                            message: res.msg
                        });  
                    }
                }).catch((error) => {
                    this.$message({
                        type: 'warning',
                        message: error.msg
                    });        
                });
            }
            // alert("AddNewTaskArrangement3");       
        },
        EditTaskArrangement() {
            let token = this.$store.getters.idToken;
            const EditTaskArrangementFormData = {
                id: this.EditTaskArrangementFormid,
                type: this.EditTaskArrangementFormtype,
                brand: this.EditTaskArrangementFormbrand,
                project: this.EditTaskArrangementFormproject,
                countrych: this.EditTaskArrangementFormcountry,
                countryID: this.EditTaskArrangementFormcountryID,
                testertranslater: this.EditTaskArrangementFormtestertranslater,
                swversion: this.EditTaskArrangementFormswversion,
                submitdate: this.EditTaskArrangementFormsubmitdate,
                swtype: this.EditTaskArrangementFormswtype,
                testperiod: this.EditTaskArrangementFormtestperiod,
                projectleader: this.EditTaskArrangementFormprojectleader,
                ppm: this.EditTaskArrangementFormppm,
                spm: this.EditTaskArrangementFormspm,
                tpm: this.EditTaskArrangementFormtpm,
                testplan: this.EditTaskArrangementFormtestplan,
                swlink: this.EditTaskArrangementFormswlink,
                password: this.EditTaskArrangementFormpassword,
                flashtool: this.EditTaskArrangementFormflashtool,
                comment: this.EditTaskArrangementFormcomment
            }
            EditTaskArrangementData (this.EditTaskArrangementFormid,EditTaskArrangementFormData,token).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '恭喜你，Modified successfully',
                        type: 'success'
                    });
                    for (var i = 0;i < this.tableData.length;i++) {
                        if (this.EditTaskArrangementFormid == this.tableData[i].id) {
                            this.tableData[i].type = EditTaskArrangementFormData.type;
                            this.tableData[i].brand = EditTaskArrangementFormData.brand;
                            this.tableData[i].project = EditTaskArrangementFormData.project;
                            this.tableData[i].countrych = EditTaskArrangementFormData.countrych;
                            this.tableData[i].countryID = EditTaskArrangementFormData.countryID;
                            this.tableData[i].testertranslater = EditTaskArrangementFormData.testertranslater;
                            this.tableData[i].swversion = EditTaskArrangementFormData.swversion;
                            this.tableData[i].submitdate = EditTaskArrangementFormData.submitdate;
                            this.tableData[i].swtype = EditTaskArrangementFormData.swtype;
                            this.tableData[i].testperiod = EditTaskArrangementFormData.testperiod;
                            this.tableData[i].projectleader = EditTaskArrangementFormData.projectleader;
                            this.tableData[i].ppm = EditTaskArrangementFormData.ppm;
                            this.tableData[i].spm = EditTaskArrangementFormData.spm;
                            this.tableData[i].tpm = EditTaskArrangementFormData.tpm;
                            this.tableData[i].testplan = EditTaskArrangementFormData.testplan;
                            this.tableData[i].swlink = EditTaskArrangementFormData.swlink;
                            this.tableData[i].password = EditTaskArrangementFormData.password;
                            this.tableData[i].flashtool = EditTaskArrangementFormData.flashtool;
                            this.tableData[i].comment = EditTaskArrangementFormData.comment;
                            console.log(this.tableData[i]);
                        }
                    }
                    GetTaskArrangementSelectOption (token).then(res => {
                        console.log(res);
                        this.selectcountryoptions = res.countrych;
                        // this.selectprojectoptions = res.project;
                        this.selectbrandoptions = res.brand;
                        this.selectswtypeoptions = res._type;
                    }).catch(error => console.log(error));
                    GetProjectInfoSelectOption (token).then(res => {
                        console.log(res);
                        this.selectprojectoptions = res.project;
                    }).catch(error => console.log(error));
                    this.dialogEditTaskArrangementVisible = false;
                    // this.$router.push({path:'/TaskArrangement'});
                }else {
                    this.$message({
                        type: 'warning',
                        message: res.msg
                    });   
                }
            }).catch((error) => {
                this.$message({
                        type: 'warning',
                        message: error.msg
                    });          
            });  
            // .catch(error => console.log(error));                      
        },
        AddNewselectcountryaction() {
            let token = this.$store.getters.idToken;
            MulitCountryInfoData ({
                countrylist: this.AddNewTaskArrangementFormcountry
            },token).then(res => {                
                console.log(res);
                this.AddNewTaskArrangementFormcountryback = res;
                console.log(this.AddNewTaskArrangementFormcountryback);
            }).catch(error => console.log(error));
        },
        AddNewselectprojecttocountryaction() {
            let token = this.$store.getters.idToken;
            TaskArrangementprojectcountryInfoData ({
                project: this.AddNewTaskArrangementFormproject,
            },token).then(res => {
                console.log(res.results);
                this.AddNewselectprojecttocountryoptions = res.results;
            }).catch(error => console.log(error));
        },
        AddNewselectprojectaction() {
            let token = this.$store.getters.idToken;
            TaskArrangementprojectInfoData ({
                project: this.AddNewTaskArrangementFormproject,
            },token).then(res => {
                console.log(res.results);
                this.AddNewTaskArrangementFormtype = res.results.type;
                this.AddNewTaskArrangementFormbrand = res.results.brand;
                this.AddNewTaskArrangementFormcountry = res.countrych;
                this.AddNewTaskArrangementFormswversion = res.results.swversion;
                // this.AddNewTaskArrangementFormswtype = res.results.;
                // this.AddNewTaskArrangementFormtestperiod = res.results.;
                this.AddNewTaskArrangementFormprojectleader = res.results.projectleader;
                this.AddNewTaskArrangementFormppm = res.results.ppm;
                this.AddNewTaskArrangementFormspm = res.results.spm;
                this.AddNewTaskArrangementFormtpm = res.results.tpm;
                this.AddNewTaskArrangementFormtestplan = res.results.testplan;
                this.AddNewTaskArrangementFormswlink = res.results.swlink;
                this.AddNewTaskArrangementFormpassword = res.results.password;
                this.AddNewTaskArrangementFormflashtool = res.results.flashtool;
                this.AddNewTaskArrangementFormcomment = res.results.comment;
                this.AddNewselectcountryaction();
            }).catch(error => console.log(error));
        },
        Editselectcountryaction() {
            let token = this.$store.getters.idToken;
            MulitCountryInfoData ({
                countrylist: this.EditTaskArrangementFormcountry
            },token).then(res => {                
                console.log(res);
                this.EditTaskArrangementFormcountryback = res;
                console.log(this.EditTaskArrangementFormcountryback);
            }).catch(error => console.log(error));
            console.log("aaaa");
        },
        // Editselectprojectaction() {
        //     let token = this.$store.getters.idToken;
        //     searchprojectInfoData ({
        //         project: this.EditTaskArrangementFormproject,
        //         SPM: "",
        //         Platform: ""
        //     },token).then(res => {                
        //         if(res.count ==1) {
        //             console.log(res.results[0]);
        //             this.EditTaskArrangementFormbrand = res.results[0].Brand;
        //             this.EditTaskArrangementFormspm = res.results[0].SPM;
        //             this.EditTaskArrangementFormtype = res.results[0].Type;
        //         }
        //     }).catch(error => console.log(error));
        // },
        exportTaskArrangement() {
            let token = this.$store.getters.idToken;
            const loading = this.$loading({
                lock: true,
                text: 'Exporting',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            if(this.selectswversionvalue == "") {
                this.$message({
                    type: 'warning',
                    message: 'Please Enter SW Version!'
                });
                loading.close();
            }else {
                exportTaskArrangementData ({
                    swversion: this.selectswversionvalue
                },token).then(res => {
                    // console.log(res);
                    if(res.code == 1) {
                        window.location.href = res.url;
                        this.$message({
                            type: 'success',
                            message: 'Export Success!'
                        });
                        loading.close();
                    }else {
                        this.$message({
                            type: 'warning',
                            message: 'Export Failed!'
                        });
                        loading.close();
                    }                    
                }).catch(error => console.log(error));
            }            
        },
        onCopy: function (e) {
            this.$message({
                type: 'success',
                message: 'You just copied: ' + e.text
            });
        },
        onError: function (e) {
            this.$message({
                type: 'warning',
                message: 'Failed to copy texts!'
            });
        }
    }
};
</script>

<style scoped>
    .searchtitle {
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
    }
    .searchbar {
        padding: 20px 0px;
        margin-top:-30px;
    }
    .AddNewTaskArrangementForm {
        font-weight: bold;
        font-size: 16px;
    }
    .formselect {
        width: 100%;
    }
</style>
